<template>
  <HeaderApp />
  <div class="mt-14"></div>

  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      (isHide == true
        ? '  '
        : $store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
    id="printDev"
  >
    <InvoiceHeader invoice_type="sold_invoices" v-if="isHide == true" />

    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("sold_invoices") }}
      </h1>
    </div>

    <!-- Filters and Controls -->
    <div
      class="px-6 py-4 border-b border-gray-200 dark:border-gray-700"
      v-if="isHide != true"
    >
      <div
        class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4"
      >
        <!-- Search and Print Actions -->
        <div class="flex items-center space-x-4">
          <BaseInput
            :modelValue="$store.state.sold_list.search"
            @update:modelValue="handleSearchInput"
            :placeholder="$t('search')"
            :prefixIcon="'fa-solid fa-search'"
            class="w-40 md:w-full"
          />
          <BaseInput
            :modelValue="$store.state.sold_list.searchBarcode"
            @update:modelValue="handleBarcodeSearchInput"
            :placeholder="$t('search_by_purchased_item_barcode')"
            :prefixIcon="'fa-solid fa-barcode'"
            class="w-40 md:w-full"
          />
          <button
            class="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors duration-200 no-print"
            @click="printReportFunc"
            id="button_print"
            v-if="$store.getters['checkPrintAccess']"
          >
            <i class="fa-solid fa-print mr-2"></i>
            {{ $t("print") }}
          </button>
        </div>

        <!-- Column Selection -->
        <div class="flex items-center space-x-4">
          <CustomMultiSelect
            v-model="selectedHeaders"
            :options="headers"
            track-by="value"
            label="text"
            :placeholder="$t('columns')"
            :header-text="$t('which_columns_to_display')"
            @update:modelValue="printCall"
          />
          <div class="w-0.5"></div>
          <button
            @click="resetToDefaultHeaders"
            class="group inline-flex items-center justify-center w-10 h-10 bg-gradient-to-br text-blue-600 dark:text-blue-400 rounded-xl border border-blue-200 dark:border-gray-600 hover:from-blue-100 hover:to-indigo-200 dark:hover:from-gray-600 dark:hover:to-gray-700 hover:shadow-lg hover:shadow-blue-200/50 dark:hover:shadow-gray-900/50 hover:scale-105 active:scale-95 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 backdrop-blur-sm"
            :title="$t('reset_to_default')"
          >
            <i
              class="fa fa-refresh text-sm group-hover:rotate-180 transition-transform duration-500"
            ></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Table Container -->
    <div class="px-6 py-4">
      <div
        class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden"
      >
        <EasyDataTable
          :key="`table-${isDark ? 'dark' : 'light'}`"
          v-model:server-options="serverOptions"
          :headers="showHeaders"
          :items="items"
          :server-items-length="serverItemsLength"
          :loading="isLoadingData"
          :alternating="false"
          :buttons-pagination="true"
          :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
          :hide-footer="isHide"
          :rows-items="[25, 50, 100, serverItemsLength]"
          rows-per-page="10"
          :table-class-name="isDark ? 'modern-dark-table' : ''"
        >
          <template #default="{ column, sortDirection }">
            <div
              :class="`flex items-center space-x-2 ${
                $store.getters['isRtl'] ? 'justify-end' : 'justify-start'
              }`"
            >
              <span class="font-semibold text-gray-700 dark:text-gray-300">{{
                column.label
              }}</span>
              <span v-if="column.sortable" class="text-gray-400">
                <i
                  v-if="sortDirection === 'asc'"
                  class="fa-solid fa-arrow-up text-blue-500"
                ></i>
                <i
                  v-else-if="sortDirection === 'desc'"
                  class="fa-solid fa-arrow-down text-blue-500"
                ></i>
                <i v-else class="fa-solid fa-arrows-up-down text-gray-400"></i>
              </span>
            </div>
          </template>
          <template #item-actions="item">
            <div class="flex items-center justify-center space-x-1">
              <a
                :href="'sale-pos/' + item.in_id"
                v-if="
                  $store.getters['checkUserAccess']({
                    id: '19',
                    action: 'detail',
                  })
                "
                class="inline-flex items-center justify-center p-2 text-green-600 dark:text-green-400 bg-green-100 dark:bg-green-900/30 hover:bg-green-200 dark:hover:bg-green-800/50 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 rounded-md transition-all duration-200"
                :title="$t('view_details')"
              >
                <i class="fa-solid fa-eye text-lg"></i>
              </a>
              
              <!-- Print Button -->
              <button
                class="inline-flex items-center justify-center p-2 text-blue-600 dark:text-blue-400 bg-blue-100 dark:bg-blue-900/30 hover:bg-blue-200 dark:hover:bg-blue-800/50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-md transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                @click="printA4Direct(item.in_id)"
                :title="$t('print_invoice')"
                :disabled="printingInvoiceId === item.in_id && isPrintLoading"
              >
                <i v-if="printingInvoiceId === item.in_id && isPrintLoading" class="fa-solid fa-spinner fa-spin text-lg"></i>
                <i v-else class="fa-solid fa-print text-lg"></i>
              </button>
              
              <button
                @click="deleteItem(item.in_id)"
                v-if="
                  $store.getters['checkUserAccess']({
                    id: '19',
                    action: 'delete',
                  })
                "
                class="inline-flex items-center justify-center p-2 text-red-600 dark:text-red-400 bg-red-100 dark:bg-red-900/30 hover:bg-red-200 dark:hover:bg-red-800/50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 rounded-md transition-all duration-200"
                :title="$t('delete')"
              >
                <i class="fa-solid fa-trash text-lg"></i>
              </button>
            </div>
          </template>
          <template #item-in_paid="item">
            <div class="text-right">
              <span class="font-semibold text-gray-900 dark:text-gray-100">
                {{ formatNumber(item.in_paid) }}
              </span>
            </div>
          </template>
          <template #item-in_price="item">
            <div class="text-right">
              <span class="font-semibold text-gray-900 dark:text-gray-100">
                {{ formatNumber(item.in_price) }}
              </span>
            </div>
          </template>
          <template #item-in_due="item">
            <div class="text-right">
              <span class="font-semibold text-gray-900 dark:text-gray-100">
                {{ formatNumber(item.in_due) }}
              </span>
            </div>
          </template>
          <template #item-cur_id="item">
            <span
              class="inline-flex items-center px-2 py-1 text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200 rounded-md"
            >
              {{ $t(item.currency.cur_name) }}
            </span>
          </template>
          <template #item-st_id="item">
            <span
              class=""
            >
              {{ $t(item.sale_type.st_name) }}
            </span>
          </template>
          <template #item-id="item">
            <span class="text-gray-900 dark:text-gray-100 font-medium">
              {{ $t(item.users.name) }}
            </span>
          </template>
          <template #item-cu_id="item">
            <span class="text-gray-900 dark:text-gray-100 font-medium">
              {{ $t(item.customer.cu_name) }}
            </span>
          </template>
          <template #item-in_cost="item">
            <div class="text-right">
              <span class="font-semibold text-gray-900 dark:text-gray-100">
                {{ formatNumber(item.in_price - item.in_cost) }}
              </span>
            </div>
          </template>
          <template #item-in_discount="item">
            <div class="text-right">
              <span class="font-semibold text-gray-900 dark:text-gray-100">
                {{ formatNumber(item.in_discount) }}
              </span>
            </div>
          </template>

          <template #item-in_status="item">
            <span
              v-if="item.in_status == 1"
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200"
            >
              <i class="fa-solid fa-check-circle mr-1"></i>
              <div class="w-1"></div>
              {{ $t("sold") }}
            </span>
            <span
              v-else
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200"
            >
              <i class="fa-solid fa-times-circle mr-1"></i>
              <div class="w-1"></div>
              {{ $t("returned") }}
            </span>
          </template>
          <template #item-in_type="item">
            <span
              v-if="item.in_type == 1"
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200"
            >
              {{ $t("sale_tak") }}
            </span>
            <span
              v-else
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200"
            >
              {{ $t("sale_jwmla") }}
            </span>
          </template>
          <template #loading>
            <div class="flex justify-center items-center py-8">
              <div
                class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
              ></div>
              <span class="ml-3 text-gray-600 dark:text-gray-400"
                >{{ $t("loading") }}...</span
              >
            </div>
          </template>
          <template #item-created_at="item">
            <span class="text-gray-600 dark:text-gray-400 text-sm">
              {{ formatDate(item.created_at) }}
            </span>
          </template>
          <template #empty-message>
            <div class="text-center py-12">
              <i class="fa-solid fa-box-open text-4xl text-gray-400 mb-4"></i>
              <p class="text-gray-500 dark:text-gray-400 text-lg font-medium">
                {{ $t("no_data_found") }}
              </p>
              <p class="text-gray-400 dark:text-gray-500 text-sm mt-2">
                {{ $t("try_adjusting_your_search_criteria") }}
              </p>
            </div>
          </template>
          <template
            #pagination="{
              prevPage,
              nextPage,
              isFirstPage,
              isLastPage,
              currentPaginationNumber,
              maxPaginationNumber,
            }"
          >
            <button :disabled="isFirstPage" @click="goToPage(1)">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-double-right'
                    : ' fa-angle-double-left')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button :disabled="isFirstPage" @click="prevPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-right'
                    : ' fa-angle-left ')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button
              v-for="page in getVisiblePages(
                currentPaginationNumber,
                maxPaginationNumber
              )"
              :key="page"
              @click="goToPage(page)"
              :class="getPageButtonClasses(page, currentPaginationNumber)"
            >
              {{ page }}
            </button>

            <div class="w-5"></div>
            <button :disabled="isLastPage" @click="nextPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-left'
                    : ' fa-angle-right')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button
              :disabled="isLastPage"
              @click="goToPage(maxPaginationNumber)"
            >
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-double-left'
                    : ' fa-angle-double-right')
                "
              ></i>
            </button>
          </template>
        </EasyDataTable>
      </div>
    </div>
  </div>

  <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  <ResultDialog ref="ResultDialog"></ResultDialog>
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import CustomMultiSelect from "../../components/Inputs/CustomMultiSelect.vue";
import { formatDate } from "../../utils/functions";
import ConfirmDialogue from "../../components/Modals/ConfirmDialogue.vue";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import { formatNumber } from "../../utils/functions";
import { FILE_URL } from "../../constants/config";
// eslint-disable-next-line no-unused-vars
import { Header, ServerOptions, Item } from "vue3-easy-data-table";
import InvoiceHeader from "../../components/Navbar/InvoiceHeader.vue";
import "../../assets/css/modern-table.css";
export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    BaseInput,
    CustomMultiSelect,
    ConfirmDialogue,
    ResultDialog,
    InvoiceHeader,
  },
  data() {
    return {
      firstName: "",
      rules: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      in_id: "",
      re_note: "",
      inputType: "text",
      isSubmited: false,
      isSubmitedEdit: false,
      current: {},
      created_at: "",
      items: [],
      serverItemsLength: 0,
      serverOptions: {
        page: 1,
        rowsPerPage: 12,
      },
      loading: false,
      isHide: false,
      selectedHeaders: [],
      columnsControl: false,
      isPrintLoading: false,
      printingInvoiceId: null,
      file_url: FILE_URL,
    };
  },
  created() {
    this.getData();
    this.selectedHeaders = [...this.headers];
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    getResultDialog(newValue, oldValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.sold_list.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.sold_list.isSuccess,
        });

        // Reset the deleteSuccess state after showing the dialog
        this.$store.commit("sold_list/SET_DELETE_SUCCESS", false);
      }
    },
    serverOptions: {
      handler() {
        this.loadFromServer();
      },
      deep: true,
    },
  },

  computed: {
    getResultDialog() {
      return this.$store.state.sold_list.isShowResultDialog;
    },

    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.sold_list.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.sold_list.isBtnLoading;
    },
    isBtnEditLoading() {
      return this.$store.state.sold_list.isBtnEditLoading;
    },
    headers() {
      var listHeader = [
        //in_id,st_id,in_price,in_paid,in_price,in_due,in_status,in_main_currency_price,admin

        { text: this.$t("invoice_id"), value: "in_id", sortable: true },
        { text: this.$t("sale_type"), value: "st_id", sortable: true },
        { text: this.$t("invoice_status"), value: "in_status", sortable: true },
        { text: this.$t("invoice_type"), value: "in_type", sortable: true },
        { text: this.$t("total_price"), value: "in_price", sortable: true },
        { text: this.$t("paid_amount"), value: "in_paid", sortable: true },
        { text: this.$t("due_amount"), value: "in_due", sortable: true },
        { text: this.$t("invoice_profit"), value: "in_cost", sortable: false },
        { text: this.$t("discount"), value: "in_discount", sortable: false },
        { text: this.$t("currency_type"), value: "cur_id", sortable: true },
        {
          text: this.$t("dolar_price"),
          value: "in_main_currency_price",
          sortable: true,
        },
        { text: this.$t("customer"), value: "cu_id", sortable: true },
        { text: this.$t("note"), value: "in_note", sortable: true },
        { text: this.$t("box"), value: "box.bo_name", sortable: true },
        { text: this.$t("admin"), value: "id", sortable: true },
        { text: this.$t("created_at"), value: "created_at", sortable: true },
        { text: this.$t("actions"), value: "actions", sortable: false },
      ];
      //remove actions column if isHide is true
      if (this.isHide == true) {
        listHeader.pop();
      }

      return listHeader;
    },
    showHeaders() {
      var temp = [];
      //cretae a for check all selectedHeaders add to temp
      for (let i = 0; i < this.selectedHeaders.length; i++) {
        for (let j = 0; j < this.headers.length; j++) {
          if (this.selectedHeaders[i].text == this.headers[j].text) {
            temp.push(this.headers[j]);
          }
        }
      }

      if (temp.length == 0) {
        temp = this.headers;
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.selectedHeaders = temp;
      }

      return temp;
    },
  },
  mounted() {
    // First load when the component is mounted
    this.loadFromServer();
    this.loadSelectedHeaders();
  },
  methods: {
    printReportFunc() {
      this.isHide = true;
      //wait 1 second
      setTimeout(() => {
        var printContents = document.getElementById("printDev").innerHTML;

        // Replace the body's innerHTML with the print contents
        document.body.innerHTML = printContents;
        var isRtl = this.$store.getters["isRtl"];
        // Set direction based on the parameter
        if (isRtl) {
          document.body.style.direction = "rtl";
        } else {
          document.body.style.direction = "ltr";
        }

        // Print the content
        window.print(); // Adjust the timeout as needed
        //reload page
      }, 100);
      //print element id invoice_print
    },
    getVisiblePages(currentPage, totalPages) {
      const numVisibleButtons = 3; // Adjust this number based on your design preference
      const pages = [];

      // Display pages 1 to numVisibleButtons (e.g., 1, 2, 3)
      if (currentPage <= Math.floor(numVisibleButtons / 2) + 1) {
        for (let i = 1; i <= Math.min(totalPages, numVisibleButtons); i++) {
          pages.push(i);
        }
      }
      // Display pages around the current page (e.g., 1, ..., 10, ..., 20)
      else {
        const startPage = Math.max(
          1,
          currentPage - Math.floor(numVisibleButtons / 2)
        );
        const endPage = Math.min(totalPages, startPage + numVisibleButtons - 1);

        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }
      }

      return pages;
    },

    // Function to get Tailwind CSS classes for each page button
    getPageButtonClasses(page, currentPage) {
      return {
        "bg-blue-500 text-white": page === currentPage,
        "bg-gray-300 text-gray-700 hover:bg-gray-400": page !== currentPage,
        "p-2 rounded-md mx-1": true, // Adjust padding and rounding based on your design
      };
    },

    goToPage(page) {
      // Implement your logic to update the current page
      //update page
      this.serverOptions.page = page;
      this.loadFromServer();
    },
    formatNumber(number) {
      return formatNumber(number);
    },
    async loadFromServer() {
      this.loading = true;

      var tempObj = { ...this.serverOptions };
      //add new field to object search
      tempObj.search = this.$store.state.sold_list.search;
      tempObj.searchBarcode = this.$store.state.sold_list.searchBarcode;
      const res = await this.$store.dispatch("sold_list/getItems", tempObj);

      this.items = res.data.data;
      this.serverItemsLength = res.data.total;
      this.loading = false;
    },
    routeTo(href) {
      //go href and refresh page
      this.$store.commit("edit_sale/SET_EDIT_SALE_CLEAR", {});
      this.$router.push({ path: href }).catch(() => {});
      //clear edit_sale state module
    },
    formatDate(date) {
      return formatDate(date);
    },
    getData() {
      //this.$store.dispatch("sold_list/getItems");
    },
    async AddItem() {
      //check form validation
      if (this.$store.state.sold_list.isBtnLoading) return;

      this.isSubmited = true;
      if (
        this.checkRulesIsError(this.in_id, "add", this.rules).isError ||
        this.checkRulesIsError(this.re_note, "add", this.rules).isError
      ) {
        return;
      }
      this.$store.state.sold_list.isBtnLoading = true;
      var res = await this.$store.dispatch("sold_list/addNewItem", {
        in_id: this.in_id,
        re_note: this.re_note,
        created_at: this.created_at,
      });
      if (res.status == 200) {
        this.in_id = "";
        this.re_note = "";
        this.isSubmited = false;
      }
    },
    checkRulesIsError(value, type, rules) {
      var isError = false;
      var errorMsg = "";
      if (type == "add") {
        if (this.isSubmited == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      if (type == "edit") {
        if (this.isSubmitedEdit == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }

      for (const rule of rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
    async deleteItem(id) {
      const ok = await this.$refs.confirmDialogue.show({
        message: this.$t("are_you_sure_remove_this_item") + id,
        okButton: this.$t("delete"),
      });
      if (ok) {
        //remove item from items array when in_id is equal to id
        this.items = this.items.filter((item) => item.in_id !== id);
        await this.$store.dispatch("sold_list/deleteItem", id);
        //call loadFromServer function to update items array
        this.loadFromServer();
      }
    },
    //edit
    async showModal(item) {
      this.current = item;
      this.current.created_at = this.current.created_at
        .toString()
        .split("T")[0];
      await this.$refs.editModal.show();
    },
    async editItem(e) {
      e.preventDefault();
      this.isSubmitedEdit = true;
      if (
        this.checkRulesIsError(this.current.in_id, "edit", this.rules)
          .isError ||
        this.checkRulesIsError(this.current.re_note, "edit", this.rules).isError
      ) {
        return;
      }
      this.$store.state.sold_list.isBtnEditLoading = true;
      var res = await this.$store.dispatch("sold_list/editItem", {
        in_id: this.current.in_id,
        re_note: this.current.re_note,
        created_at: this.current.created_at,
      });

      this.isSubmitedEdit = false;
      this.$store.state.sold_list.isBtnEditLoading = false;
      if (res.status == 200) {
        this.$refs.editModal.hide();
        this.loadFromServer();
      }
    },
    handleSearchInput(value) {
      this.$store.commit("sold_list/SET_SEARCH", value);
      this.loadFromServer();
      this.serverOptions.page = 1;
    },
    handleBarcodeSearchInput(value) {
      this.$store.commit("sold_list/SET_SEARCH_BARCODE", value);
      this.loadFromServer();
      this.serverOptions.page = 1;
    },
    loadSelectedHeaders() {
      // Load selected headers from localStorage
      const savedHeaders = localStorage.getItem("saleListSelectedHeaders");
      if (savedHeaders) {
        try {
          const parsedHeaders = JSON.parse(savedHeaders);
          // Filter to only include headers that exist in current headers list
          this.selectedHeaders = this.headers.filter((header) =>
            parsedHeaders.some((saved) => saved.value === header.value)
          );
        } catch (error) {
          console.error("Error loading saved headers:", error);
          this.selectedHeaders = [...this.headers];
        }
      } else {
        // If no saved headers, select all by default
        this.selectedHeaders = [...this.headers];
      }
    },
    saveSelectedHeaders() {
      // Save selected headers to localStorage
      try {
        localStorage.setItem(
          "saleListSelectedHeaders",
          JSON.stringify(this.selectedHeaders)
        );
      } catch (error) {
        console.error("Error saving headers:", error);
      }
    },
    printCall(selectedHeaders) {
      // Handle column selection changes
      if (selectedHeaders && Array.isArray(selectedHeaders)) {
        this.selectedHeaders = selectedHeaders;
        this.saveSelectedHeaders();
      }
    },
    resetToDefaultHeaders() {
      // Reset to select all headers
      this.selectedHeaders = [...this.headers];
      this.saveSelectedHeaders();
    },
    async printA4Direct(invoiceId) {
      this.isPrintLoading = true;
      this.printingInvoiceId = invoiceId;
      try {
        // Fetch full invoice with relations (sold_item, customer, currency, etc.) exactly like Home.vue uses
        let fullInvoiceResp = await this.$store.dispatch("edit_sale/getCurrentInvoice", { in_id: invoiceId });
        const invoice = (fullInvoiceResp && fullInvoiceResp.data) ? fullInvoiceResp.data : this.$store.state.edit_sale.currentInvoice;
        if (!invoice) {
          console.error('Invoice not found');
          this.isPrintLoading = false;
          this.printingInvoiceId = null;
          return;
        }
        // Normalize sold items property to match Home.vue expectation
        if (!invoice.sold_item && invoice.invoice_items) {
          invoice.sold_item = invoice.invoice_items;
        }

        // Get customer debt balance if customer exists
        let beforeDebtIQD = 0;
        let beforeDebtUSD = 0;
        let balanceUpToAndIncludingDateIQD = 0;
        let balanceUpToAndIncludingDateUSD = 0;

        if (invoice.customer && invoice.customer.cu_id) {
          try {
            const res = await this.$store.dispatch("customer/getCurrentDebt", {
              cu_id: invoice.customer.cu_id,
              created_at: invoice.created_at,
            });
            beforeDebtIQD = res.balance_before_date.IQD;
            beforeDebtUSD = res.balance_before_date.USD;
            balanceUpToAndIncludingDateIQD = res.balance_up_to_and_including_date.IQD;
            balanceUpToAndIncludingDateUSD = res.balance_up_to_and_including_date.USD;
          } catch (error) {
            console.error('Error getting customer debt:', error);
          }
        }

        // Create A4 invoice content
        const invoiceContent = this.generateA4Invoice(
          invoice,
          beforeDebtIQD,
          beforeDebtUSD,
          balanceUpToAndIncludingDateIQD,
          balanceUpToAndIncludingDateUSD
        );
        
        // Print the invoice
        this.printContent(invoiceContent);
        
      } catch (error) {
        console.error('Error printing A4 invoice:', error);
        this.isPrintLoading = false;
      } finally {
        this.isPrintLoading = false;
        this.printingInvoiceId = null;
      }
    },
    generateA4Invoice(invoice, beforeDebtIQD = 0, beforeDebtUSD = 0, balanceUpToAndIncludingDateIQD = 0, balanceUpToAndIncludingDateUSD = 0) {
      const settings = this.$store.state.settings.settings || {};
      const currency = invoice.currency || { cur_name: 'IQD' };
      const cur_id = currency.cur_id || 1;
      
      // Calculate totals from sold items
      const soldItems = invoice.sold_item || [];
      console.log('Invoice sold items:', soldItems);
      console.log('Invoice data:', invoice);
      const sumPriceWithoutDiscount = soldItems.reduce((sum, item) => sum + (item.si_quantity * item.si_sale_price), 0);
      const sumDiscount = soldItems.reduce((sum, item) => sum + (item.si_discount || 0), 0);
      const sumPrice = sumPriceWithoutDiscount - sumDiscount;
      const totalBonusItems = soldItems.reduce((sum, item) => sum + (item.si_bonus_quantity || 0), 0);
      
      return `
        <html>
        <head>
          <title>${this.$t("invoice_title")}</title>
          <style>
            @font-face {
              font-family: 'kurd';
              src: url('https://storage.wisesale.app/Rabar_022-Busi21Jx.ttf') format('truetype');
            }
            body {
              font-family: 'kurd', sans-serif;
              direction: rtl;
              text-align: right;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
              background: white;
              margin: 0;
            }
            @page {
              size: A4;
            }
            .my_font { font-family: 'kurd' !important; }
            .invoice-container {
              max-width: 210mm;
              margin: 0 auto;
              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
              padding: 10mm;
            }
            .header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding-bottom: 20px;
            }
            .headerBorder {
              border-bottom: 2px solid #eee;
            }
            .header h1 {
              font-size: 28px;
              color: #7165E3;
              margin: 0;
            }
            .header p {
              margin: 0;
              font-size: 12px;
              color: #777;
            }
            .header .company-info {
              text-align: right;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
            }
            th, td {
              border: 1px solid #eee;
              padding: 10px;
              text-align: center;
            }
            th {
              background-color: #7165E3;
              color: white;
            }
            tr:nth-child(even) {
              background-color: #f9f9f9;
            }
            .summary-box {
              margin-top: 20px;
              background: #f2f2f2;
              padding: 10px;
              border-radius: 5px;
            }
            .summary-box h3 {
              margin: 5px 0;
              color: #7165E3;
            }
            .summary-box1 h3 {
              margin: 1px 0;
              color: #7165E3;
            }
            .footer {
              margin-top: 40px;
              text-align: center;
              font-size: 14px;
            }
          </style>
        </head>
        <body>
          <div class="invoice-container">
            <div class="header headerBorder">
              <div class="company-info">
                <h1>${settings.app_name || 'Store'}</h1>
                <p>${this.$t("phone number")}: ${settings.set_phone_number || ''}${settings.set_phone_number2 ? ' - ' + settings.set_phone_number2 : ''}</p>
                <p>${this.$t("address")}: ${settings.set_address || ''}</p>
              </div>
              <div class="company-logo">
                ${settings.set_logo ? `<img src="${this.file_url + settings.set_logo}" alt="Company Logo" style="max-width: 100px; max-height: 100px;" />` : ''}
              </div>
              <div>
                <h1 style="color: #333; font-size: 20px;">${settings.set_header_invoice || ''}</h1>
                <p><strong>${this.$t("invoice_id")}:</strong> ${invoice.in_id || "-"}</p>
                <p><strong>${this.$t("date")}:</strong> ${this.formatDate(invoice.created_at)}</p>
              </div>
            </div>
            
            <div class="header">
              <h2 style="color: #333; font-size: 18px;">
                ${this.$t("customer_name")} : ${invoice.customer ? invoice.customer.cu_id + ' - ' + invoice.customer.cu_name : this.$t("walk_in_customer")}
              </h2>
              ${invoice.in_status != 1 ? `<p style="color: red; font-size: 16px; font-weight: bold;">${this.$t("returned")}</p>` : ''}
            </div>
            
            <table>
              <thead>
                <tr>
                  <th>${this.$t("#")}</th>
                  <th>${this.$t("item_name")}</th>
                  <th>${this.$t("price_dana")}</th>
                  <th>${this.$t("quantity")}</th>
                  ${totalBonusItems > 0 ? `<th>${this.$t("bonus")}</th>` : ''}
                  ${sumDiscount > 0 ? `<th>${this.$t("discount")}</th>` : ''}
                  <th>${this.$t("total_price")}</th>
                </tr>
              </thead>
              <tbody>
                ${soldItems.map((item, index) => `
                  <tr>
                    <td>${index + 1}</td>
                    <td>${item.item ? item.item.i_name : 'Unknown Item'}</td>
                    <td>${this.formatNumber(item.si_sale_price)}</td>
                    <td>${this.formatNumber(item.si_quantity)}</td>
                    ${totalBonusItems > 0 ? `<td>${item.si_bonus_quantity > 0 ? this.formatNumber(item.si_bonus_quantity) : '-'}</td>` : ''}
                    ${sumDiscount > 0 ? `<td>${this.formatNumber(item.si_discount || 0)}</td>` : ''}
                    <td>${this.formatNumber(item.si_quantity * item.si_sale_price - (item.si_discount || 0))}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
            
            ${invoice.in_note ? `
              <div class="summary-box" style="margin: 10px 0 !important; padding: 8px !important;">
                <h3 style="margin: 0 0 5px 0 !important;">${this.$t("note")}</h3>
                <p style="margin: 0 !important;">${invoice.in_note}</p>
              </div>
            ` : ''}
            
            <div class="header">
              ${(beforeDebtIQD > 0 || beforeDebtIQD < 0 || beforeDebtUSD > 0 || beforeDebtUSD < 0 || balanceUpToAndIncludingDateIQD > 0 || balanceUpToAndIncludingDateIQD < 0 || balanceUpToAndIncludingDateUSD > 0 || balanceUpToAndIncludingDateUSD < 0) ? `
                <div style="display: flex; justify-content: flex-end; margin-top: 20px;">
                  <div style="background-color: #f2f2f2; padding: 15px; border-radius: 5px; border: 1px solid #ddd; box-sizing: border-box; min-width: 200px;">
                    <div style="padding: 4px 0;">
                      <div style="font-size: 14px;">
                        ${this.$t("balance_before")}: 
                        <div style="font-size: 14px; font-weight: bold; color: red;">
                          ${this.formatNumber(beforeDebtIQD)} ${this.$t("dinar")}
                        </div>
                      </div>
                      <div style="font-size: 14px; font-weight: bold; color: red;">
                        ${this.formatNumber(beforeDebtUSD)} ${this.$t("dollar")}
                      </div>
                    </div>
                    <div style="padding: 4px 0; margin-top: 10px;">
                      <div style="font-size: 14px;">
                        ${this.$t("balance_after")}:
                      </div>
                      <div style="font-size: 14px; font-weight: bold; color: red;">
                        ${this.formatNumber(balanceUpToAndIncludingDateIQD)} ${this.$t("dinar")}
                      </div>
                      <div style="font-size: 14px; font-weight: bold; color: red;">
                        ${this.formatNumber(balanceUpToAndIncludingDateUSD)} ${this.$t("dollar")}
                      </div>
                    </div>
                  </div>
                </div>
              ` : ''}
              
              <div style="display: flex; justify-content: flex-end; margin-top: 20px;">
                <div style="background-color: #f2f2f2; padding: 15px; border-radius: 5px; border: 1px solid #ddd; box-sizing: border-box;">
                  <div style="display: flex; justify-content: space-between; padding: 4px 0;">
                    <span style="font-size: 17px; font-weight: normal; color: #555;">${this.$t("items_price")}:</span>
                    <span style="font-size: 17px; font-weight: normal; color: #333;">${this.formatNumber(sumPriceWithoutDiscount)} ${this.$t(cur_id == 1 ? "dinar" : "dollar")}</span>
                  </div>
                  ${sumDiscount > 0 ? `
                    <div style="display: flex; justify-content: space-between; padding: 4px 0;">
                      <span style="font-size: 17px; font-weight: normal; color: #555;">${this.$t("discount")}:</span>
                      <span style="font-size: 17px; font-weight: normal; color: #333;">${this.formatNumber(sumDiscount)} ${this.$t(cur_id == 1 ? "dinar" : "dollar")}</span>
                    </div>
                  ` : ''}
                  <div style="display: flex; justify-content: space-between; padding: 4px 0; font-size: 18px; color: #333;">
                    <span style="color: #555;">${this.$t("final_price")}:</span>
                    <span style="font-weight: bold;">${this.formatNumber(sumPrice)} ${this.$t(cur_id == 1 ? "dinar" : "dollar")}</span>
                  </div>
                  ${invoice.in_due > 0 ? `
                    <div style="display: flex; justify-content: space-between; padding: 4px 0;">
                      <span style="font-size: 18px; font-weight: normal; color: #555;">${this.$t("paid_money")}:</span>
                      <span style="font-size: 18px; font-weight: bold; color: #008000;">${this.formatNumber(invoice.in_paid)} ${this.$t(cur_id == 1 ? "dinar" : "dollar")}</span>
                    </div>
                    <div style="display: flex; justify-content: space-between; padding: 4px 0">
                      <span style="font-size: 18px; color: #555;">${this.$t("debt")}:</span>
                      <span style="font-size: 18px; font-weight: bold; color: red;">${this.formatNumber(invoice.in_due)} ${this.$t(cur_id == 1 ? "dinar" : "dollar")}</span>
                    </div>
                  ` : ''}
                </div>
              </div>
            </div>
            
          
          </div>
        </body>
        </html>
      `;
    },
    printContent(content) {
      // Create a hidden iframe for printing
      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";

      document.body.appendChild(iframe);

      // Write content to iframe
      iframe.contentDocument.write(content);
      iframe.contentDocument.close();

      // Print after content is loaded
      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow.print();
          
          // Clean up
          setTimeout(() => {
            document.body.removeChild(iframe);
            this.isPrintLoading = false;
          }, 1000);
        }, 500);
      };
    },
  },
};
</script>
